import { CheckCircleOutlineOutlined, SendRounded } from "@mui/icons-material";
import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import TextFieldCustom from "../../component/textFieldCustom";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Api from "../../api/RestApi.json";
export default function YoutubeCard(params) {
  const goTo = useNavigate();
  const [deskripsi, setDeskripsi] = React.useState(params.data?.deskripsi);
  const [save, setSave] = React.useState(false);

  const storePost = async (event) => {
    event.preventDefault();
    setSave(false);

    const formData = {
      id: params.id,
      nama: params.title,
      deskripsi: deskripsi,
      susunan: "-",
    };

    var responseData = null;
    try {
      if (params.data) {
        responseData = await axios.put(
          Api.komponen + "/" + params.id,
          formData
        );
      } else {
        responseData = await axios.post(Api.komponen, formData);
        goTo("/komponen");
      }
      setSave(true);
    } catch (error) {
      console.error("Error add Data: ", error);
    }
  };
  return (
    <Box padding={2} bgcolor={"white"} borderRadius={4}>
      <Grid
        container
        direction={"column"}
        spacing={2}
        padding={2}
        alignItems={"start"}
      >
        <Grid size={12}>
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Typography variant="h3" fontWeight={"bold"} align="left">
              {params.title}
            </Typography>
          </Stack>
        </Grid>
        <Grid size={12}>
          <form onSubmit={storePost}>
            <Grid container spacing={2}>
              <Grid size={12}>
                <TextFieldCustom
                  title="URL Youtube"
                  name="deskripsi"
                  id="deskripsi"
                  value={deskripsi}
                  onChange={(e) => setDeskripsi(e.target.value)}
                  type="url"
                  label="https://www.youtube.com/embed/V1luJN8Wu0s?si=Kt18-LOKR3r2Ai5x"
                  required={true}
                  multiline={true}
                />
                <Typography variant="caption"></Typography>
              </Grid>
              <Grid size={12}>
                <Box justifySelf={"center"} mt={4}>
                  <Button
                                      type="submit"
                                      variant="contained"
                                      color="success"
                                      size="large"
                                      startIcon={<SendRounded/>}
                                    >
                                      Kirim
                                    </Button>
                </Box>
              </Grid>
            </Grid>
          </form>
        </Grid>
        <Grid size={12}>
          {save && (
            <Box flex={1} justifySelf={"center"}>
              <Typography
                variant="body2"
                color="success.main"
                sx={{ display: "flex", alignItems: "center" }}
              >
                <CheckCircleOutlineOutlined sx={{ mr: 1 }} />
                Data berhasil Tersimpan
              </Typography>
            </Box>
          )}
        </Grid>
      </Grid>
    </Box>
  );
}
